// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2e8om","top":"styles_top__A4CIj","left":"styles_left__1Wnfs","description":"styles_description__-qaHc"};